import React, { useEffect, useState } from 'react';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import LandingPage from './components/LandingPage';
import Profile from './components/Profile';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from "react-redux";
import { index } from './components/redux';
import store from './components/redux/store';
import { loadFeedPosts, loadCurrentUserPosts, loadAllUsers } from './components/redux';
import UserSettings from './components/UserSettings';
import NewUser from './components/NewUser';
import SignupNewUser from './components/SignupNewUser';
import Marketplace from './components/Marketplace';
import SinglePost from './components/SinglePost';
import Search from './components/Search';


const firebaseConfig = {
  apiKey: "AIzaSyB71GXCLQLlXpu43fR2DsfsX0m6a7GuUXg",
  authDomain: "cuisn-23003.firebaseapp.com",
  projectId: "cuisn-23003",
  storageBucket: "cuisn-23003.appspot.com",
  messagingSenderId: "638744031221",
  appId: "1:638744031221:web:4e1456d6d7cb51bcb7fabc",
  measurementId: "G-E5E8PQ7KYN"
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();

const provider = new firebase.auth.GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });

export const signInWithGoogle = (navigate) => {
  auth.signInWithPopup(provider)
    .then((result) => {
      // The signed-in user info
      var user = result.user;
      var useremail = user.email;
      var userId = user.uid;

      const userRef = firebase.firestore().collection('users').doc(userId);

      userRef.get()
        .then((doc) => {
          if (doc.exists) {
            const userData = doc.data();

            if (userData.name && userData.username && userData.location) {
              window.location = '/';
            } else {
              navigate('/user/new')
            }
          } else {
            userRef.set({
              email: useremail,
              name: '',
              role: '',
              username: '',
              image: '',
              location: '',
              dob: '',
              following: 0,
              follower: 0,
              time: firebase.firestore.FieldValue.serverTimestamp()
            })
            .then(() => {
              window.location = '/user/new';
            })
            .catch((error) => {
              console.log('Error inserting user into Firestore:', error);
            });
          }
        })
        .catch((error) => {
          console.log('Error getting user document:', error);
        });
    })
    .catch((error) => {
      console.log('Error signing in with Google:', error);
    });
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

const App = () => {
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    loadFeedPosts();
    loadAllUsers();
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        setLoggedIn(false);
      } else {
        index();
        loadCurrentUserPosts();
        setLoggedIn(true);
      }
    });
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <Routes>
          {loggedIn ? (
            <>
              <Route exact path='/' element={<LandingPage/>}/>
              <Route path='/account/settings' element={<UserSettings/>}/>
              <Route path='/profile' element={<Profile/>}/>
              <Route path='/user/new' element={<NewUser/>}/>
              <Route path='/user/new/onboard' element={<SignupNewUser/>}/>
              <Route path='/marketplace' element={<Marketplace/>}/>
              <Route path='/post' element={<SinglePost/>}/>
              <Route path='/search' element={<Search/>}/>
            </>
          ) : (
            <>
              <Route exact path='/' element={<LandingPage/>}/>
              <Route path='/profile' element={<Profile/>}/>
              <Route path='/post' element={<SinglePost/>}/>
              <Route path='/search' element={<Search/>}/>
            </>
          )}
        </Routes>
      </Router>
    </Provider>
  )
}
export default App